import React, { useEffect, useState } from "react";
import { DialogTitle, Modal, ModalClose, ModalDialog } from "@mui/joy";
import Input from "@mui/joy/Input";
import Button from "@mui/joy/Button";
import Typography from "@mui/joy/Typography";
import GeneralApiService from "../../axios/Axios";
import { toast } from "react-toastify";

interface RotaModalProps {
    openState: boolean;
    parentCallback: () => void;
}

export default function RotaModal({ openState, parentCallback }: RotaModalProps) {
    const [email, setEmail] = useState("");
    const [open, setOpen] = useState(openState);
    const [locationName, setLocationName] = useState<string | null>(null);

    useEffect(() => {
        setOpen(openState);
        if (openState) {
            setLocationName(localStorage.getItem('location'));
        }
    }, [openState]);

    const closeModal = () => {
        setOpen(false);
        parentCallback();
    };

    const sendEmail = () => {
        const send = async () => {
            try {
                await GeneralApiService.sendRotaEmail(email);
                toast.success(`Rota sent to ${email}!`);
            } catch (error) {
                console.error("Failed to send rota email:", error);
                toast.error("Failed to send rota email.");
            }
        };
        send();
        closeModal();
    };

    return (
        <Modal
            open={open}
            onClose={closeModal}
            slotProps={{
                backdrop: {
                    sx: {
                        backdropFilter: 'none',
                        backgroundColor: 'rgb(108 108 108 / 60%)',
                    },
                },
            }}
        >
            <ModalDialog sx={{
                width: { xs: '90vw', sm: 'auto' },
                maxWidth: { xs: '90vw', sm: '400px' },
            }}>
                <ModalClose />
                <DialogTitle>Sending Rota For {locationName}</DialogTitle>
                <Typography level="title-md">Enter Email</Typography>
                <Input
                    onChange={(event) => setEmail(event.target.value)}
                    placeholder="Email Address"
                    type="email"
                />
                <Button onClick={sendEmail} sx={{ mt: 2 }}>
                    Send Rota
                </Button>
            </ModalDialog>
        </Modal>
    );
}